<template>
    <div v-if="!loading">
        <highcharts
            :constructor-type="'chart'"
            :options="chartOptions"
            class="chart"
            ref="highcharts"
        ></highcharts>
    </div>
    <div class="text-center pt-3 pb-3" v-else>
        <img src="loader.svg" style="width: 100px; height: 100px" />
    </div>
</template>

<script>
import Utils from '@/utils'
import ChartsConfig from '@/mixins/Charts.Config.js'

export default {
    props: ['data', 'loading', 'onClick'],

    data() {
        return {
            chart_offsetWidth: null,
            chart_offsetHeight: null,
            class_info: null,
            column_keys: {
                normal: 'Estoque',
                news: 'Novo',
                discontinuing: 'Em. Desc',
                discontinued: 'Desc',
                obsolete: 'Obs.'
            },
            line_keys: { tc: 'TC', tcTarget: 'TC Meta' },
            stack_keys: {
                normal: 'all',
                news: 'all',
                discontinuing: 'all',
                discontinued: 'all',
                obsolete: 'obsolete'
            },
            chartOptions: {
                chart: {
                    className: 'stock stock_chart_resize'
                },
                title: {
                    text: 'Estoque'
                },
                colors: [
                    '#7cb5ec',
                    '#434348',
                    '#90ed7d',
                    '#f7a35c',
                    '#8085e9',
                    '#f15c80',
                    '#e4d354'
                ],

                exporting: {
                    enabled: true
                },

                xAxis: {
                    categories: ['AA', 'A', 'B', 'C', 'CC']
                },
                yAxis: [
                    {
                        opposite: false,
                        min: 0,
                        // Primary yAxis
                        labels: {
                            formatter: function(v) {
                                return (
                                    'R$ ' +
                                    Utils.formatNumber(
                                        this.value,
                                        'float',
                                        true
                                    )
                                )
                            }
                        },
                        title: {
                            text: ''
                        }
                    },
                    {
                        // Secondary yAxis
                        opposite: true,
                        startOnTick: true,
                        endOnTick: true,
                        showLastLabel: true,
                        tickPixelInterval: 40,
                        minPadding: 0,
                        maxPadding: 0,
                        minRange: 1,
                        min: 0,
                        maxRange: 20,
                        title: {
                            text: ''
                        },
                        labels: {
                            formatter: function() {
                                return Utils.formatNumber(
                                    this.value,
                                    'float',
                                    true
                                )
                            }
                        }
                    }
                ],
                tooltip: {
                    shared: true
                },

                plotOptions: {
                    column: {
                        borderRadius: 4,
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true,
                            formatter: function() {
                                return (
                                    'R$ ' +
                                    Utils.formatNumber(this.y, 'float', true)
                                )
                            }
                        }
                    },
                    series: {
                        cursor: 'pointer',
                        events: {
                            click: event => {
                                let curve = event.point.category
                                let colorIndex = this.chartOptions.colors.indexOf(
                                    event.point.color
                                )

                                let elem =
                                    colorIndex <
                                    Object.keys(this.column_keys).length
                                        ? Object.keys(this.column_keys)[
                                            colorIndex
                                            ]
                                        : Object.keys(this.line_keys)[
                                        colorIndex -
                                        Object.keys(this.column_keys)
                                            .length
                                            ]
                                this.onClick(curve, elem)
                            },

                            legendItemClick: function() {
                                if (!this.visible) {
                                    this.chart.series[this.index].show()
                                } else {
                                    let check = false

                                    if (this.index <= 4)
                                        check = this.chart.series.some(
                                            (serie, index) =>
                                                !serie.visible &&
                                                this.index <= 4 &&
                                                index <= 4
                                        )
                                    else
                                        check = this.chart.series.some(
                                            (serie, index) =>
                                                !serie.visible &&
                                                this.index > 4 &&
                                                index > 4
                                        )

                                    if (!check) {
                                        this.chart.series.map(
                                            (serie, index) => {
                                                if (index === this.index)
                                                    serie.show()
                                                else if (
                                                    this.index <= 4 &&
                                                    index <= 4
                                                )
                                                    serie.hide()
                                                else if (
                                                    this.index > 4 &&
                                                    index > 4
                                                )
                                                    serie.hide()
                                            }
                                        )
                                    } else {
                                        this.chart.series.map(
                                            (serie, index) => {
                                                if (
                                                    this.index <= 4 &&
                                                    index <= 4
                                                )
                                                    serie.show()
                                                else if (
                                                    this.index > 4 &&
                                                    index > 4
                                                )
                                                    serie.show()
                                            }
                                        )
                                    }
                                }

                                return false
                            }
                        }
                    }
                },
                series: []
            }
        }
    },
    mixins: [ChartsConfig],
    watch: {
        data: {
            handler: function(data) {
                if (!data) return
                this.chartOptions.series = []

                Object.keys(data)
                    .filter(key => this.column_keys[key])
                    .forEach((key, index) => {
                        this.chartOptions.series.push({
                            name: this.column_keys[key],
                            type: 'column',
                            stack: this.stack_keys[key],
                            tooltip: {
                                valuePrefix: 'R$ '
                            },
                            color: this.chartOptions.colors[index],
                            data: data[key].map(value =>
                                value ? Number(Number(value).toFixed(2)) : 0
                            )
                        })
                    })

                Object.keys(data)
                    .filter(key => this.line_keys[key])
                    .forEach((key, index) => {
                        this.chartOptions.series.push({
                            name: this.line_keys[key],
                            type: 'spline',
                            colorByPoint: true,
                            styledMode: true,
                            yAxis: 1,
                            color: this.chartOptions.colors[index],
                            data: data[key].map(value =>
                                value == 'Inf.'
                                    ? null
                                    : Number(Number(value).toFixed(0))
                            )
                        })
                    })
            }
        }
    }
}
</script>
<style></style>
